import { PriceFacetViewModel } from './api'

export function isPriceFacetViewModel(item: unknown): item is PriceFacetViewModel {
    if (!item || typeof item !== 'object') {
        return false
    }

    const obj = item as PriceFacetViewModel
    return (
        typeof obj.fromPrice === 'number' ||
        typeof obj.toPrice === 'number' ||
        typeof obj.selectedFromPrice === 'number' ||
        typeof obj.selectedToPrice === 'number'
    )
}
